<h4 class="title">TO-DO List</h4>

<!-- <div class="card-box">
    <div class="row" style="padding: 0px 0px 23px 10px;">
        <div class="col-md-3">
            <h5 class="form-lable">User Group:</h5>
            <input type="text" pInputText [(ngModel)]="Name" placeholder="User group">
        </div>

        <div class="col-md-6 mt-20">
            <button type="button" class="btn btn-primary">Add</button>
            <button type="button" class="btn btn-primary btn-bg-blue">Export to Excel</button>
        </div>

    </div>
</div> -->
<div class="row">

    <div class="col-md-2">
        <h4 class="title-f" style="color: #0a2440;font-weight: 600;border-bottom: 2px solid;">Filter</h4>
        <div>
            <h4 class="title-f">Nationality</h4>
            <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"
                style="width: auto;margin-right: 5px;position: relative;top: 2px;">
            <label for="vehicle1" style="font-weight: 500;font-size: 12px;"> India</label><br>
            <input type="checkbox" id="vehicle2" name="vehicle1" value="Bike"
                style="width: auto;margin-right: 5px;position: relative;top: 2px;">
            <label for="vehicle2" style="font-weight: 500;font-size: 12px;"> Dubai</label><br>
            <input type="checkbox" id="vehicle3" name="vehicle1" value="Bike"
                style="width: auto;margin-right: 5px;position: relative;top: 2px;">
            <label for="vehicle3" style="font-weight: 500;font-size: 12px;"> USA</label><br>
            <input type="checkbox" id="vehicle4" name="vehicle1" value="Bike"
                style="width: auto;margin-right: 5px;position: relative;top: 2px;">
            <label for="vehicle4" style="font-weight: 500;font-size: 12px;"> UK</label><br>
            <p style="font-size: 12px;color: #2196f3;">+05 More</p>
        </div>
        <hr />
        <div>
            <h4 class="title-f">Account</h4>
            <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"
                style="width: auto;margin-right: 5px;position: relative;top: 2px;">
            <label for="vehicle1" style="font-weight: 500;font-size: 12px;"> New</label><br>
            <input type="checkbox" id="vehicle2" name="vehicle1" value="Bike"
                style="width: auto;margin-right: 5px;position: relative;top: 2px;">
            <label for="vehicle2" style="font-weight: 500;font-size: 12px;"> Existing</label><br>
            <input type="checkbox" id="vehicle3" name="vehicle1" value="Bike"
                style="width: auto;margin-right: 5px;position: relative;top: 2px;">
            <label for="vehicle3" style="font-weight: 500;font-size: 12px;"> Re-activated</label><br>

        </div>
        <hr />
        <div>
            <h4 class="title-f">Previous agent</h4>
            <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"
                style="width: auto;margin-right: 5px;position: relative;top: 2px;">
            <label for="vehicle1" style="font-weight: 500;font-size: 12px;"> Agent-001</label><br>
            <input type="checkbox" id="vehicle2" name="vehicle1" value="Bike"
                style="width: auto;margin-right: 5px;position: relative;top: 2px;">
            <label for="vehicle2" style="font-weight: 500;font-size: 12px;"> Agent-002</label><br>
            <input type="checkbox" id="vehicle3" name="vehicle1" value="Bike"
                style="width: auto;margin-right: 5px;position: relative;top: 2px;">
            <label for="vehicle3" style="font-weight: 500;font-size: 12px;"> Agent-003</label><br>
            <input type="checkbox" id="vehicle4" name="vehicle1" value="Bike"
                style="width: auto;margin-right: 5px;position: relative;top: 2px;">
            <label for="vehicle4" style="font-weight: 500;font-size: 12px;"> Agent-004</label><br>
            <p style="font-size: 12px;color: #2196f3;">+05 More</p>
        </div>
        <div>
            <h4 class="title-f">Outstanding amount</h4>
            <h5>Amount: {{rangeValues[0] + ' - ' + rangeValues[1]}}</h5>
            <p-slider [(ngModel)]="rangeValues" [range]="true"></p-slider>
        </div>
    </div>
    <div class="col-md-10">
        <div class="row" style="margin-bottom: 10px;">
            <div class="col-md-4">
                <div class="search-hero" style="margin-top: 15px;">
                    <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                        [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
                </div>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Type of allocation:</h5>
                <p-dropdown [options]="type" [(ngModel)]="cli_type" placeholder="Select" optionLabel="y" [showClear]="true">
                </p-dropdown>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Allocation Status of accounts:</h5>
                <p-dropdown [options]="type" [(ngModel)]="cli_type" placeholder="Select" optionLabel="y" [showClear]="true">
                </p-dropdown>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Touched/Untouched:</h5>
                <p-dropdown [options]="type" [(ngModel)]="cli_type" placeholder="Select" optionLabel="y" [showClear]="true">
                </p-dropdown>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Follow-up Date:</h5>
                <p-calendar [showIcon]="true" inputId="icon"></p-calendar>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Allocation date:</h5>
                <p-calendar [showIcon]="true" inputId="icon"></p-calendar>
            </div>
        </div>
        <div class="doc-table">
            <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
                [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [globalFilterFields]="['type']">

                <ng-template pTemplate="header">
                    <tr class="thhead">
                        <th class="th-1">
                            S.No
                        </th>
                        <th>
                            Customer UID
                        </th>
                        <th>
                            CIF / CID </th>
                        <th>
                            Customer Full Name
                        <th>
                            Passport Number
                        </th>
                        <th>
                            Total outstanding
                        </th>
                        <th>
                            Nationality
                        </th>
                        <th>
                            Follow-up date
                        </th>
                        <th>
                            No of accounts/products
                        </th>
                        <th>
                            Status
                        </th>
                        <th style="width: 110px;text-align:center">
                            Action
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-i="rowIndex">
                    <tr class="tdrow">
                        <td>{{i+1}}</td>
                        <td>Type-1</td>
                        <td>Type-1</td>
                        <td>Type-1</td>
                        <td>Type-1</td>
                        <td>Type-1</td>
                        <td>Type-1</td>
                        <td>Type-1</td>
                        <td>Type-1</td>
                        <td>Type-1</td>
                        <td class="act">
                            <i style="color: #2196f3;" class="fa fa-info-circle" aria-hidden="true"
                                pTooltip="View Account" (click)="cus360()"></i>
                            <!-- <i style="color: #4CAF50;" class="fa fa-check" aria-hidden="true"
                                pTooltip="Mark as resolved"></i>
                            <i style="color: #3a2cfd;" class="fa fa-plus-circle" aria-hidden="true"
                                pTooltip="Add to my list"></i> -->

                        </td>
                    </tr>
                </ng-template>
             </p-table>  </div>

        </div>
    </div>
</div>